import React, { useMemo } from "react";
import { marked } from "marked";
import Modal from "../../../../shared/components/dashboard-layout/components/modal/modalComponent";
import TERMS_CONTENT_MD from "../../terms-content";
import "./terms-modal.scss";

/**
 * Terms & Conditions modal with two modes:
 *
 * 1. Acceptance mode (isAccepted=false):
 *    - Blocking — overlay click and close icon do not dismiss.
 *    - User must click "I Accept the Terms" to proceed.
 *
 * 2. View-only mode (isAccepted=true):
 *    - Non-blocking — can be dismissed via close icon or "Close" button.
 */
const TermsModal = ({ isVisible, onAccept, onClose, isAccepted, isAccepting }) => {
  const termsHtml = useMemo(() => marked.parse(TERMS_CONTENT_MD), []);

  return (
    <Modal
      isVisible={isVisible}
      onClose={isAccepted ? onClose : undefined}
      header="Terms of Service & SLA"
      positiveButtonLabel={!isAccepted ? "I Accept the Terms" : undefined}
      positiveButtonAction={!isAccepted ? onAccept : undefined}
      cancelButtonLabel={isAccepted ? "Close" : undefined}
      cancelButtonAction={isAccepted ? onClose : undefined}
      className={`terms-modal ${!isAccepted ? "terms-modal--blocking" : ""}`}
    >
      <div
        className="terms-content"
        dangerouslySetInnerHTML={{ __html: termsHtml }}
      />
      {isAccepting && (
        <div className="terms-accepting-overlay">
          <span>Accepting...</span>
        </div>
      )}
    </Modal>
  );
};

export default TermsModal;
